// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + ".08d9f7c7f41350f9bc39fb7457dc11ec.js";
};